module.exports = KalturaPlayer.ui.preact;